var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlacklistRiderSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.175 12.5H17.825C17.315 12.5 16.595 12.8 16.235 13.16L13.16 16.235C12.8 16.595 12.5 17.315 12.5 17.825V22.175C12.5 22.685 12.8 23.405 13.16 23.765L16.235 26.84C16.595 27.2 17.315 27.5 17.825 27.5H22.175C22.685 27.5 23.405 27.2 23.765 26.84L26.84 23.765C27.2 23.405 27.5 22.685 27.5 22.175V17.825C27.5 17.315 27.2 16.595 26.84 16.235L23.765 13.16C23.405 12.8 22.685 12.5 22.175 12.5Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 25.3101L25.31 14.7051",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklistRiderSettingsIcon);
export default __webpack_public_path__ + "static/media/blacklist-rider-settings-icon.f26ee910abafc41ff811f4abfc6328af.svg";
export { ForwardRef as ReactComponent };